import { getVeloConstant } from '../../react/shared/lib/veloConstants'
import { showSnackbar } from './snackbar'

// Class variants must stay in sync with the follow_button component
// in lib/veloplanner_ex_web/components/user_sidebar.ex.
const FOLLOWING_CLASSES = ['border', 'border-gray-300', 'text-gray-700', 'hover:bg-gray-50']
const NOT_FOLLOWING_CLASSES = ['bg-brand', 'text-white', 'hover:bg-brand/90']

export function initFollowButtons() {
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement | null
    const button = target?.closest<HTMLElement>('[data-follow-button]')
    if (!button) {
      return
    }

    void handleFollowButtonClick(button)
  })
}

async function handleFollowButtonClick(button: HTMLElement) {
  if (!getVeloConstant('isUserLoggedIn', false)) {
    redirectToLogin()
    return
  }

  if (button.dataset.busy === 'true') {
    return
  }

  button.dataset.busy = 'true'
  const isFollowing = button.dataset.following === 'true'

  try {
    const response = await fetch(`/api/internal/users/${button.dataset.userId}/follow`, {
      method: isFollowing ? 'DELETE' : 'POST',
      headers: {
        'X-CSRF-Token': getVeloConstant('csrfToken'),
      },
    })

    if (!response.ok) {
      throw new Error(`Follow toggle failed (status ${response.status})`)
    }

    updateButton(button, !isFollowing)
  } catch {
    showSnackbar('error', button.dataset.errorMessage || 'Something went wrong')
  } finally {
    delete button.dataset.busy
  }
}

function redirectToLogin() {
  const loginPath = getVeloConstant('routes.login')
  const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
  window.location.assign(`${loginPath}?return_to=${returnTo}`)
}

function updateButton(button: HTMLElement, isFollowing: boolean) {
  button.dataset.following = String(isFollowing)
  button.textContent = isFollowing
    ? (button.dataset.unfollowLabel ?? 'Unfollow')
    : (button.dataset.followLabel ?? 'Follow')

  if (isFollowing) {
    button.classList.remove(...NOT_FOLLOWING_CLASSES)
    button.classList.add(...FOLLOWING_CLASSES)
  } else {
    button.classList.remove(...FOLLOWING_CLASSES)
    button.classList.add(...NOT_FOLLOWING_CLASSES)
  }
}
